import * as React from 'react';
import { toast } from 'react-hot-toast';
import { useState, useContext } from 'react';
import { Link as RouterLink } from 'react-router-dom';

import {
  UserContext,
} from '../../context/userContext/userContext';

import {
  ShoppingCartContext,
} from '../../context/shoppingCartContext/shoppingCartContext';

import {
  useStyle,
} from '../../context/styleContext/styleContext';

import Box from '@mui/material/Box';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Container from '@mui/material/Container';
import Divider from '@mui/material/Divider';
import MenuItem from '@mui/material/MenuItem';
import Drawer from '@mui/material/Drawer';
import Badge from '@mui/material/Badge';
import Menu from '@mui/material/Menu';
import Collapse from '@mui/material/Collapse';
import ListItemText from '@mui/material/ListItemText';

import MenuIcon from '@mui/icons-material/Menu';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMoreRounded';
import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded';
import ExpandLessRoundedIcon from '@mui/icons-material/ExpandLessRounded';

import logo from '../../images/LightIcon.svg';
import shoppingCartIcon from '../../images/shopping_cart.svg';

export default function Header() {
  const { style } = useStyle();
  const { user, setUser } = useContext(UserContext);
  const { cartItems } = useContext(ShoppingCartContext);
  const { cartBundles } = useContext(ShoppingCartContext);

  const [mobileOpen, setMobileOpen] = useState(false);
  const [mobileMoreOpen, setMobileMoreOpen] = useState(false);
  const [moreAnchorEl, setMoreAnchorEl] = useState(null);

  const moreOpen = Boolean(moreAnchorEl);

  const closeNavigationMenus = () => {
    setMobileOpen(false);
    setMobileMoreOpen(false);
    setMoreAnchorEl(null);
  };

  const logout = () => {
    localStorage.removeItem('token');
    setUser(null);
    closeNavigationMenus();
    toast.success('Logout successful');
  };

  const primaryLinks = [
    {
      label: 'Home',
      path: '/',
    },
    {
      label: 'Shop Plugins',
      path: '/products',
    },
    {
      label: 'Bundles',
      path: '/bundles',
    },
    {
      label: 'Subscribe',
      path: '/subscribe',
    },
    {
      label: 'My Gear',
      path: '/my-gear',
    },
  ];

  const moreLinks = [
    {
      label: 'About',
      path: '/about',
    },
    {
      label: 'Learn',
      path: '/learning',
    },
    {
      label: 'Redeem a Code',
      path: '/redeem',
    },
    {
      label: 'Contact',
      path: '/contact',
    },
    {
      label: 'Privacy Policy',
      path: '/privacy-policy',
    },
    {
      label: 'Terms',
      path: '/terms',
    },
    {
      label: 'Return Policy',
      path: '/return-policy',
    },
    {
      label: 'FAQ',
      path: '/faq',
    },
    {
      label: 'Support',
      path: '/support',
    },
  ];

  return (
    <Box sx={{ display: 'flex' }} style={{ display: 'flex' }}>
      <AppBar
        position="fixed"
        enableColorOnDark
        // Inline geometry keeps the header stable before Emotion/MUI CSS loads.
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          width: '100%',
          height: '60px',
          minHeight: '60px',
          maxHeight: '60px',
        }}
        sx={{
          boxShadow: 0,
          bgcolor: style.color1,
          backgroundImage: 'none',
          minHeight: '60px',
          maxHeight: '60px',
          borderBottom: `1px solid ${style.color2}`,
          backdropFilter: 'blur(12px)',
        }}
      >
        <Container maxWidth="lg">
          <Toolbar
            disableGutters
            style={{
              display: 'flex',
              alignItems: 'center',
              height: '60px',
              minHeight: '60px',
            }}
            sx={{
              minHeight: '60px !important',
            }}
          >
            <Box
              sx={{
                flexGrow: 1,
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <Button
                component={RouterLink}
                to="/"
                onClick={closeNavigationMenus}
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  flexShrink: 0,
                  padding: 0,
                  minWidth: 0,
                }}
                sx={{
                  textTransform: 'none',
                  p: 0,
                  minWidth: 0,
                  borderRadius: '10px',
                  transition: 'filter 0.25s ease',

                  '&:hover': {
                    filter: 'brightness(1.15)',
                  },
                }}
              >
                <Box
                  style={{ display: 'flex', alignItems: 'center' }}
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  <Box
                    style={{
                      width: '42px',
                      height: '42px',
                      flex: '0 0 42px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                    sx={{
                      width: 42,
                      height: 42,
                      display: 'flex',
                    }}
                  >
                    <img
                      src={logo}
                      alt="Parish Audio Logo"
                      width={42}
                      height={42}
                      loading="eager"
                      style={{
                        display: 'block',
                        width: '42px',
                        height: '42px',
                        objectFit: 'contain',
                        flexShrink: 0,
                      }}
                    />
                  </Box>

                  <Box
                    style={{
                      marginLeft: '8px',
                      fontSize: '1.12rem',
                      fontWeight: 700,
                      whiteSpace: 'nowrap',
                    }}
                    sx={{
                      fontSize: '1.12rem',
                      ml: 1,
                      color: style.color4,
                      fontWeight: 700,
                      letterSpacing: '-0.02em',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    Parish Audio
                  </Box>
                </Box>
              </Button>

              <Box
                sx={{
                  display: {
                    xs: 'none',
                    md: 'flex',
                  },
                  ml: 3,
                }}
              >
                {primaryLinks.map((link) => (
                  <Button
                    key={link.label}
                    component={RouterLink}
                    to={link.path}
                    onClick={closeNavigationMenus}
                    sx={{
                      color: style.color4,
                      textTransform: 'none',
                      fontWeight: 600,
                      px: 1.4,
                      borderRadius: '10px',
                      whiteSpace: 'nowrap',
                      '&:hover': {
                        backgroundColor:
                          'rgba(255,255,255,0.05)',
                      },
                    }}
                  >
                    {link.label}
                  </Button>
                ))}

                <Button
                  onClick={(event) => {
                    setMoreAnchorEl(event.currentTarget);
                  }}
                  endIcon={<ExpandMoreRoundedIcon />}
                  sx={{
                    color: style.color4,
                    textTransform: 'none',
                    fontWeight: 600,
                    px: 1.4,
                    borderRadius: '10px',

                    '&:hover': {
                      backgroundColor:
                        'rgba(255,255,255,0.05)',
                    },
                  }}
                >
                  More
                </Button>

                <Menu
                  anchorEl={moreAnchorEl}
                  open={moreOpen}
                  onClose={() => {
                    setMoreAnchorEl(null);
                  }}
                  PaperProps={{
                    sx: {
                      mt: 1,
                      minWidth: 220,
                      background: style.color1,
                      color: style.color4,
                      border: `1px solid ${style.color2}`,
                      borderRadius: '14px',
                      boxShadow:
                        '0 18px 40px rgba(0,0,0,0.32)',
                    },
                  }}
                >
                  {moreLinks.map((link) => (
                    <MenuItem
                      key={link.label}
                      component={RouterLink}
                      to={link.path}
                      onClick={closeNavigationMenus}
                      sx={{
                        py: 1,
                        color: 'inherit',
                        textDecoration: 'none',

                        '&:hover': {
                          backgroundColor:
                            'rgba(255,255,255,0.05)',
                        },
                      }}
                    >
                      <ListItemText
                        primary={link.label}
                        primaryTypographyProps={{
                          fontSize: '0.95rem',
                          fontWeight: 500,
                        }}
                      />
                    </MenuItem>
                  ))}
                </Menu>
              </Box>
            </Box>

            <Box
              sx={{
                display: {
                  xs: 'none',
                  md: 'flex',
                },
                gap: 0.25,
                alignItems: 'center',
              }}
            >
              {user ? (
                <>
                  {user.isAdmin && (
                    <Button
                      component={RouterLink}
                      to="/admin"
                      onClick={closeNavigationMenus}
                      sx={{
                        color: style.color4,
                        textTransform: 'none',
                        fontWeight: 600,
                        borderRadius: '10px',
                      }}
                    >
                      Admin
                    </Button>
                  )}

                  <Button
                    component={RouterLink}
                    to="/account"
                    onClick={closeNavigationMenus}
                    sx={{
                      color: style.color4,
                      textTransform: 'none',
                      fontWeight: 600,
                      borderRadius: '10px',
                    }}
                  >
                    Account
                  </Button>

                  <Button
                    onClick={logout}
                    sx={{
                      color: style.color4,
                      textTransform: 'none',
                      fontWeight: 600,
                      borderRadius: '10px',
                    }}
                  >
                    Logout
                  </Button>
                </>
              ) : (
                <>
                  <Button
                    component={RouterLink}
                    to="/login"
                    onClick={closeNavigationMenus}
                    sx={{
                      color: style.color4,
                      textTransform: 'none',
                      fontWeight: 600,
                      borderRadius: '10px',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    Sign in
                  </Button>

                  <Button
                    component={RouterLink}
                    to="/register"
                    onClick={closeNavigationMenus}
                    sx={{
                      color: style.color4,
                      textTransform: 'none',
                      fontWeight: 600,
                      borderRadius: '10px',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    Sign up
                  </Button>
                </>
              )}
            </Box>

            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                ml: 1,
              }}
            >
              <RouterLink
                to="/shopping-cart"
                aria-label="Shopping cart"
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  textDecoration: 'none',
                }}
              >
                <Badge
                  badgeContent={cartItems.length + cartBundles.length}
                  color="primary"
                  overlap="circular"
                >
                  <img
                    src={shoppingCartIcon}
                    alt=""
                    width={30}
                    height={30}
                    loading="eager"
                    style={{
                      display: 'block',
                      width: '30px',
                      height: '30px',
                      objectFit: 'contain',
                    }}
                  />
                </Badge>
              </RouterLink>
            </Box>

            <Box
              sx={{
                display: {
                  xs: 'flex',
                  md: 'none',
                },
                ml: 1,
              }}
            >
              <IconButton
                aria-label="Menu button"
                onClick={() => {
                  setMobileOpen(true);
                }}
                sx={{
                  color: style.color4,
                  borderRadius: '10px',

                  '&:hover': {
                    backgroundColor:
                      'rgba(255,255,255,0.05)',
                  },
                }}
              >
                <MenuIcon
                  sx={{
                    fontSize: '28px',
                  }}
                />
              </IconButton>

              <Drawer
                anchor="right"
                open={mobileOpen}
                onClose={closeNavigationMenus}
                PaperProps={{
                  sx: {
                    width: '86%',
                    maxWidth: 340,
                    background: style.color1,
                    color: style.color4,
                    borderLeft:
                      `1px solid ${style.color2}`,
                    boxShadow:
                      '-8px 0 30px rgba(0,0,0,0.35)',
                  },
                }}
              >
                <Box
                  sx={{
                    p: 1.5,
                    height: '100%',
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      mb: 1,
                      px: 0.5,
                    }}
                  >
                    <Box
                      sx={{
                        fontWeight: 700,
                        fontSize: '1rem',
                        color: style.color4,
                      }}
                    >
                      Menu
                    </Box>

                    <IconButton
                      aria-label="Close menu"
                      onClick={closeNavigationMenus}
                      sx={{
                        color: style.color4,
                        borderRadius: '10px',
                      }}
                    >
                      <CloseRoundedIcon
                        sx={{
                          fontSize: '24px',
                        }}
                      />
                    </IconButton>
                  </Box>

                  <Box
                    sx={{
                      borderRadius: '16px',
                      background: style.darkPanel,
                      border:
                        '1px solid rgba(255,255,255,0.08)',
                      overflow: 'hidden',
                    }}
                  >
                    {primaryLinks.map((link, index) => (
                      <React.Fragment key={link.label}>
                        <MenuItem
                          component={RouterLink}
                          to={link.path}
                          onClick={closeNavigationMenus}
                          sx={{
                            py: 1,
                            px: 1.5,
                            minHeight: 44,
                            color: 'inherit',
                            textDecoration: 'none',

                            '&:hover': {
                              backgroundColor:
                                'rgba(255,255,255,0.05)',
                            },
                          }}
                        >
                          <ListItemText
                            primary={link.label}
                            primaryTypographyProps={{
                              fontSize: '0.96rem',
                              fontWeight: 600,
                              color: style.color4,
                            }}
                          />
                        </MenuItem>

                        {index !==
                          primaryLinks.length - 1 && (
                          <Divider
                            sx={{
                              borderColor:
                                'rgba(255,255,255,0.06)',
                            }}
                          />
                        )}
                      </React.Fragment>
                    ))}

                    <Divider
                      sx={{
                        borderColor:
                          'rgba(255,255,255,0.06)',
                      }}
                    />

                    <MenuItem
                      onClick={() => {
                        setMobileMoreOpen(
                          (previous) => !previous
                        );
                      }}
                      sx={{
                        py: 1,
                        px: 1.5,
                        minHeight: 44,

                        '&:hover': {
                          backgroundColor:
                            'rgba(255,255,255,0.05)',
                        },
                      }}
                    >
                      <ListItemText
                        primary="More"
                        primaryTypographyProps={{
                          fontSize: '0.96rem',
                          fontWeight: 600,
                          color: style.color4,
                        }}
                      />

                      {mobileMoreOpen ? (
                        <ExpandLessRoundedIcon
                          sx={{
                            color: style.color3,
                          }}
                        />
                      ) : (
                        <ChevronRightRoundedIcon
                          sx={{
                            color: style.color3,
                          }}
                        />
                      )}
                    </MenuItem>

                    <Collapse
                      in={mobileMoreOpen}
                      timeout="auto"
                      unmountOnExit
                    >
                      <Box
                        sx={{
                          background: style.darkPanel,
                          borderTop:
                            '1px solid rgba(255,255,255,0.05)',
                        }}
                      >
                        {moreLinks.map(
                          (link, index) => (
                            <React.Fragment
                              key={link.label}
                            >
                              <MenuItem
                                component={RouterLink}
                                to={link.path}
                                onClick={
                                  closeNavigationMenus
                                }
                                sx={{
                                  py: 0.9,
                                  px: 2.25,
                                  minHeight: 40,
                                  color: 'inherit',
                                  textDecoration: 'none',

                                  '&:hover': {
                                    backgroundColor:
                                      'rgba(255,255,255,0.04)',
                                  },
                                }}
                              >
                                <ListItemText
                                  primary={link.label}
                                  primaryTypographyProps={{
                                    fontSize: '0.92rem',
                                    fontWeight: 500,
                                    color: style.color3,
                                  }}
                                />
                              </MenuItem>

                              {index !==
                                moreLinks.length - 1 && (
                                <Divider
                                  sx={{
                                    borderColor:
                                      'rgba(255,255,255,0.04)',
                                  }}
                                />
                              )}
                            </React.Fragment>
                          )
                        )}
                      </Box>
                    </Collapse>
                  </Box>

                  <Box
                    sx={{
                      mt: 1.25,
                      borderRadius: '16px',
                      backgroundColor: style.darkPanel,
                      border:
                        '1px solid rgba(255,255,255,0.08)',
                      overflow: 'hidden',
                    }}
                  >
                    {!user ? (
                      <>
                        <MenuItem
                          component={RouterLink}
                          to="/login"
                          onClick={closeNavigationMenus}
                          sx={{
                            py: 1,
                            px: 1.5,
                            minHeight: 44,
                            color: 'inherit',
                            textDecoration: 'none',

                            '&:hover': {
                              backgroundColor:
                                'rgba(255,255,255,0.05)',
                            },
                          }}
                        >
                          <ListItemText
                            primary="Sign In"
                            primaryTypographyProps={{
                              fontSize: '0.96rem',
                              fontWeight: 600,
                              whiteSpace: 'nowrap',
                            }}
                          />
                        </MenuItem>

                        <Divider
                          sx={{
                            borderColor:
                              'rgba(255,255,255,0.06)',
                          }}
                        />

                        <MenuItem
                          component={RouterLink}
                          to="/register"
                          onClick={closeNavigationMenus}
                          sx={{
                            py: 1,
                            px: 1.5,
                            minHeight: 44,
                            color: 'inherit',
                            textDecoration: 'none',

                            '&:hover': {
                              backgroundColor:
                                'rgba(255,255,255,0.05)',
                            },
                          }}
                        >
                          <ListItemText
                            primary="Create Account"
                            primaryTypographyProps={{
                              fontSize: '0.96rem',
                              fontWeight: 600,
                              whiteSpace: 'nowrap',
                            }}
                          />
                        </MenuItem>
                      </>
                    ) : (
                      <>
                        <MenuItem
                          component={RouterLink}
                          to="/account"
                          onClick={closeNavigationMenus}
                          sx={{
                            py: 1,
                            px: 1.5,
                            minHeight: 44,
                            color: 'inherit',
                            textDecoration: 'none',

                            '&:hover': {
                              backgroundColor:
                                'rgba(255,255,255,0.05)',
                            },
                          }}
                        >
                          <ListItemText
                            primary="Account"
                            primaryTypographyProps={{
                              fontSize: '0.96rem',
                              fontWeight: 600,
                            }}
                          />
                        </MenuItem>

                        <Divider
                          sx={{
                            borderColor:
                              'rgba(255,255,255,0.06)',
                          }}
                        />

                        <MenuItem
                          onClick={logout}
                          sx={{
                            py: 1,
                            px: 1.5,
                            minHeight: 44,

                            '&:hover': {
                              backgroundColor:
                                'rgba(255,255,255,0.05)',
                            },
                          }}
                        >
                          <ListItemText
                            primary="Log Out"
                            primaryTypographyProps={{
                              fontSize: '0.96rem',
                              fontWeight: 600,
                            }}
                          />
                        </MenuItem>
                      </>
                    )}
                  </Box>
                </Box>
              </Drawer>
            </Box>
          </Toolbar>
        </Container>
      </AppBar>
    </Box>
  );
}
